export const siteTenantsApiErrorsTranslations = {
  TENANT_INVITATION_ALREADY_EXISTS:
    'siteTenants:tenants.tenantInvitationAlreadyExists',
} as const;
